// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.header.hide-acc {
  height: 60px;
  background: #191919;
}

.tileName {
  margin-left: 10px !important;
}

.headerlogo {
  margin-left: 10%;
}

#common-login-container .close-btn {
  font-size: 20px;
  padding: 10px;
  position: absolute;
  right: 33px;
  top: -11px;
}
#common-login-container #loginModal-box {
  display: none;
   box-shadow: none;
   box-shadow: none;
   box-shadow: none;
   box-shadow: none;
   box-shadow: none;
   border-radius: 0 0 0 0;
   border-radius: 0 0 0 0;
   border-radius: 0 0 0 0;
   border-radius: 0 0 0 0;
   border-radius: 0 0 0 0;
  background: #333;
  color: #ccc;
  line-height: 15px;
  padding: 0px 2px 0px;
  position: absolute;
  right: -35px;
  top: 100%;
  visibility: visible;
  max-height: 600px;
  width: 335px;
  z-index: 999;
  height: 270px;
  text-align: left;
}
#common-login-container #loginModal-box.active {
  display: inline-block;
}
@media (max-width: 1024px) {
  #common-login-container #loginModal-box {
    position: fixed;
    width: 100%;
    top: 50px;
    right: 0px;
  }
  #common-login-container #loginModal-box .main-menu {
    background: #333;
  }
}
#common-login-container #loginModal-box .heading {
  cursor: default;
  font: normal 22px Omnes-ATT-W02, Arial !important;
  color: #fff;
  padding: 15px 20px !important;
  border-top: none !important;
}
#common-login-container #loginModal-box .subHeading {
  font-size: 18px;
  font-family: Omnes-ATT-W02, Arial;
  color: #FFFFFF;
  text-align: left;
}
#common-login-container #loginModal-box .content {
  font-family: Omnes-ATT-W02, Arial;
  color: #FFFFFF !important;
  font-size: 14px;
}
#common-login-container #loginModal-box ul li {
  border-top: 1px solid #69707b;
  font-family: Omnes-ATT-W02, Arial;
  font-size: 14px;
  padding: 0 20px;
  color: #FFFFFF !important;
}
#common-login-container #loginModal-box ul li.logoutBtn {
  display: none;
}
#common-login-container #loginModal-box ul li a {
  padding: 15px 0;
}
#common-login-container #loginModal-box ul li a:hover {
  cursor: pointer;
}
#common-login-container #loginModal-box ul li:hover {
  background-color: #69707b !important;
}
#common-login-container #loginModal-box ul .heading:hover {
  background-color: #333 !important;
}

.firstnet-logo img {
  padding: 6px 0 11px;
  max-width: 347px;
  max-height: 54px;
}

.main-menu {
  max-height: 600px;
}
.main-menu .close-btn {
  left: 280px;
  padding: 0;
}
.main-menu .close-btn .icon-close::before {
  padding: 20px 10px 0;
}
.main-menu li a {
  padding-left: 15px;
}
.main-menu li a:focus {
  padding-left: 9px;
}
.main-menu li a:hover {
  padding-left: 9px;
}

.menu-seperator {
  border-top: 1px solid #959595;
}

.global-logo::after {
  height: 36px;
}

.hamburger-fn {
  margin-left: 20px;
}

.logBtn {
  padding-right: 20px;
  padding-left: 10px;
}
@media (max-width: 1024px) {
  .logBtn {
    font-size: 14px;
  }
}

@media only screen and (min-width: 1024px) {
  .hamburgerDesktop {
    display: none !important;
  }
}
@media (max-width: 1024px) {
  .hamburgerDesktop {
    display: block !important;
  }
}
@media (max-width: 1024px) {
  .container-box {
    height: 50px;
  }
  .container-box .user-info {
    height: 50px;
  }
  .firstnet-logo {
    line-height: 0;
    margin-left: -33px;
    padding: 15px 0 16px;
  }
  .firstnet-logo img {
    content: url('firstnetLogoWhite.b1b396dd916137e0.png');
    height: 19px;
    padding: 0;
  }
  .header.hide-acc {
    height: 50px;
    overflow: hidden;
    padding: 0;
  }
  .hamburger {
    margin-left: 0;
  }
  .headerlogo {
    margin-left: -4%;
  }
  .tileName {
    margin-left: 0px !important;
  }
  .logBtn {
    padding-right: 0;
  }
  .main-menu {
    background: white;
  }
  .menu-btn {
    border: 0;
    width: 50px;
  }
  .menu-btn #icon-log-out {
    margin-right: -10px;
  }
  body.m-open::after, body.d-open::after {
    background: rgba(0, 0, 0, 0.8);
  }
  .user-profile a {
    margin: 0;
  }
}
.logoutBtn, .loginBtn {
  font-size: 14px !important;
}

.hamburger .main-menu li.menu-seperator {
  border-top: 1px solid #959595;
}

.logoutBtn, .loginBtn, .log-out-text {
  cursor: pointer;
}

@-moz-document url-prefix() {
  @media (max-width: 1024px) {
    .headerIcon {
      margin-bottom: 8px;
      font-size: 26px;
    }
    .headerHam {
      margin-bottom: 9px;
    }
    .iconClose {
      margin-left: 66px;
    }
  }
}
.dropdownMenu {
  float: right;
  margin-right: 22px;
  margin-top: -34px;
}

.text {
  margin-left: 52px;
}

@media (max-width: 1024px) {
  .header {
    position: fixed;
    z-index: 2;
  }
}
@media (min-width: 700px) {
  .dropdownMenu {
    margin-top: -32px;
  }
  .text {
    margin-left: 35px !important;
  }
  .fortab {
    width: 285px !important;
  }
}
.fortab {
  width: 200px !important;
}

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  hr {
    width: 116%;
    margin-left: -46px !important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 400px) {
  hr {
    width: 115%;
    margin-left: -46px !important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 700px) {
  hr {
    width: 111%;
    margin-left: -46px !important;
  }
}

.menu-sidebar .active {
  background-color: #009FDB;
}

.menu-sidebar .has-subnav a {
  padding-left: 11px;
}

@media (max-width: 1024px) {
  .header {
    width: 100%;
    z-index: 2;
  }
}
.nav-mobile {
  background: #446CB3;
  color: #FFF;
  padding: 0;
  margin: 0;
  cursor: auto;
  font-size: 18px;
  list-style-type: none;
  box-shadow: 0 5px 5px -5px #333;
}
.nav-mobile:after {
  content: "";
  display: table;
  clear: both;
}
.nav-mobile svg {
  height: 45px;
  width: 65px;
  padding: 9px;
  margin-top: 4px;
  margin-left: -18px;
}
.nav-mobile svg path {
  fill: #ffffff;
}
.nav-mobile svg.icon-close {
  display: none;
  padding: 15px;
}
.nav-mobile li {
  width: 100%;
  height: 45px;
  line-height: 33px;
  text-align: center;
  float: left;
}
.nav-mobile li a {
  display: block;
  color: white;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
.nav-mobile .menu-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  display: block;
}
.nav-mobile .menu-button:after {
  opacity: 0;
  top: 45px;
  content: "";
  width: 100vw;
  display: block;
  position: fixed;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  content: "";
  pointer-events: none;
  transition: opacity 0.2s cubic-bezier(0, 0, 0.3, 1);
  transition-delay: 0.1s;
}
.nav-mobile #menu-toggle {
  display: none;
}
.nav-mobile #menu-toggle.active ~ .menu-button .icon-close, .nav-mobile #menu-toggle:checked ~ .menu-button .icon-close {
  display: block;
}
.nav-mobile #menu-toggle.active ~ .menu-button .icon-open, .nav-mobile #menu-toggle:checked ~ .menu-button .icon-open {
  display: none;
}
.nav-mobile #menu-toggle.active ~ .menu-button:after, .nav-mobile #menu-toggle:checked ~ .menu-button:after {
  opacity: 1;
  pointer-events: auto;
  transition: opacity 0.3s cubic-bezier(0, 0, 0.3, 1);
}
.nav-mobile #menu-toggle.active ~ .menu-sidebar, .nav-mobile #menu-toggle:checked ~ .menu-sidebar {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0, 0, 0.3, 1);
}
.nav-mobile .nav-text {
  position: relative;
  vertical-align: middle;
  width: 190px;
  height: 12px;
  font-weight: 400;
  margin-left: 10px;
  font-family: "Omnes-ATT-W02";
  font-size: 12px;
}
.nav-mobile .menu-container {
  width: 65px;
  float: left;
  cursor: pointer;
  position: absolute;
}
.nav-mobile .menu-container .menu-sidebar {
  box-shadow: 5px 0 5px -5px #333;
  display: block;
  width: 75%;
  bottom: 0;
  background: black;
  color: #333;
  position: fixed;
  transform: translateX(-405px);
  transition: transform 0.3s cubic-bezier(0, 0, 0.3, 1);
  top: 48px;
  left: 0px;
  z-index: 2;
  list-style-type: none;
  padding: 0;
  max-width: 400px;
}
.nav-mobile .menu-container .menu-sidebar .arrow {
  position: absolute;
  line-height: 50px;
  font-size: 32px;
  color: #555;
  top: 0;
  z-index: 0;
}
.nav-mobile .menu-container .menu-sidebar .arrow.left {
  left: 25px;
}
.nav-mobile .menu-container .menu-sidebar .arrow.right {
  right: 25px;
}
.nav-mobile .menu-container .menu-sidebar li {
  height: 48px;
  line-height: 48px;
  font-size: 12px;
  text-align: left;
  position: relative;
}
.nav-mobile .menu-container .menu-sidebar li .menu-sub {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 0;
  overflow: hidden;
  background: white;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0, 0, 0.3, 1);
  border-left: 1px solid #ccc;
  list-style-type: none;
  padding: 0;
  margin: 0;
  z-index: 2;
  max-width: 400px;
}
.nav-mobile .menu-container .menu-sidebar li .menu-sub li {
  overflow: hidden;
}
.nav-mobile .menu-container .menu-sidebar li .menu-sub .menu-sub-title {
  padding-left: 50px;
}
.nav-mobile .menu-container .menu-sidebar li .submenu-label {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: block;
}
.nav-mobile .menu-container .menu-sidebar li .submenu-toggle {
  display: none;
}
.nav-mobile .menu-container .menu-sidebar li .submenu-toggle.active ~ .menu-sub, .nav-mobile .menu-container .menu-sidebar li .submenu-toggle:checked ~ .menu-sub {
  width: 65vw;
  visibility: visible;
  z-index: 1;
  transition: width 0.35s cubic-bezier(0, 0, 0.3, 1);
}

.last-login-info {
  color: #fff;
  font-size: 13px;
  margin-right: 5px;
}

.last-login-time {
  color: #fff;
  font-size: 13px;
  margin-right: 5px;
}

.login-info {
  color: #fff;
}

@media only screen and (min-width: 1024px) {
  .hide-mobile-view {
    display: inline-block !important;
  }
}
@media only screen and (max-width: 1024px) {
  .hide-mobile-view {
    display: none !important;
  }
  .last-login-info {
    margin-left: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/header/header.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EAEE,YAAA;EACA,mBAAA;AAkJF;;AAhJA;EACE,4BAAA;AAmJF;;AAhJA;EACE,gBAAA;AAmJF;;AA/IE;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAkJJ;AAhJE;EACE,aAAA;GFYA,gBAAA;GAAA,gBAAA;GAAA,gBAAA;GAAA,gBAAA;GAAA,gBAAA;GAAA,sBAAA;GAAA,sBAAA;GAAA,sBAAA;GAAA,sBAAA;GAAA,sBAAA;EETA,gBAAA;EACA,WAAA;EAEA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAyJJ;AAxJI;EACE,qBAAA;AA0JN;AF5KI;EEDF;IAsBI,eAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;EA2JJ;EA1JI;IACE,gBAAA;EA4JN;AACF;AA1JE;EACE,eAAA;EACA,iDAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;AA4JJ;AA1JE;EACE,eAAA;EACA,iCAAA;EACA,cAAA;EACA,gBAAA;AA4JJ;AA1JE;EACE,iCAAA;EACA,yBAAA;EACA,eAAA;AA4JJ;AAzJM;EACE,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA2JR;AA1JQ;EACE,aAAA;AA4JV;AA1JM;EACE,eAAA;AA4JR;AA1JM;EACE,eAAA;AA4JR;AAzJI;EACE,oCAAA;AA2JN;AAzJI;EACE,iCAAA;AA2JN;;AArJA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AAwJF;;AArJA;EACE,iBAAA;AAwJF;AAvJE;EACE,WAAA;EACA,UAAA;AAyJJ;AAvJI;EACE,oBAAA;AAyJN;AApJI;EACE,kBAAA;AAsJN;AApJM;EACE,iBAAA;AAsJR;AAnJM;EACE,iBAAA;AAqJR;;AA7IA;EACE,6BAAA;AAgJF;;AA7IA;EACE,YAAA;AAgJF;;AA7IA;EACE,iBAAA;AAgJF;;AA7IA;EACE,mBAAA;EACA,kBAAA;AAgJF;AF1QI;EEwHJ;IAKI,eAAA;EAiJF;AACF;;AA9IA;EACE;IACE,wBAAA;EAiJF;AACF;AA9IA;EACA;IACE,yBAAA;EAgJA;AACF;AF1RI;EEgJF;IACE,YAAA;EA6IF;EA3IE;IACE,YAAA;EA6IJ;EAzIA;IACE,cAAA;IACA,kBAAA;IACA,oBAAA;EA2IF;EAzIE;IACE,sDAAA;IACA,YAAA;IACA,UAAA;EA2IJ;EAtIA;IACE,YAAA;IACA,gBAAA;IACA,UAAA;EAwIF;EArIA;IACE,cAAA;EAuIF;EApIF;IACE,gBAAA;EAsIA;EApIF;IACE,2BAAA;EAsIA;EAnIA;IACE,gBAAA;EAqIF;EAlIA;IAEE,iBAAA;EAmIF;EA/HA;IACE,SAAA;IACA,WAAA;EAiIF;EAhIE;IACE,mBAAA;EAkIJ;EA1HI;IACE,8BAAA;EA4HN;EAtHE;IACE,SAAA;EAwHJ;AACF;AApHA;EACI,0BAAA;AAsHJ;;AAnHA;EACI,6BAAA;AAsHJ;;AAnHA;EACE,eAAA;AAsHF;;AAnHA;EFrOI;IEuOF;MAEE,kBAAA;MACA,eAAA;IAqHA;IAnHF;MAEE,kBAAA;IAoHA;IAlHF;MAEI,iBAAA;IAmHF;EACF;AACF;AAjHE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AAmHJ;;AAjHE;EACE,iBAAA;AAoHJ;;AAlHE;EACE;IAEE,eAAA;IAEA,UAAA;EAmHJ;AACF;AAhHA;EACE;IACA,iBAAA;EAkHA;EAjHA;IACE,4BAAA;EAmHF;EAjHA;IACE,uBAAA;EAmHF;AACF;AAjHA;EACE,uBAAA;AAmHF;;AAhHA;EACE,gBAAA;EACA,mBAAA;AAmHF;AF1YI;EEqRJ;IAII,WAAA;IACA,6BAAA;EAqHF;AACF;AApHE;EAPF;IAQI,WAAA;IACA,6BAAA;EAuHF;AACF;AAtHI;EAXJ;IAYI,WAAA;IACA,6BAAA;EAyHF;AACF;;AAtHA;EACE,yBAAA;AAyHF;;AAvHA;EACA,kBAAA;AA0HA;;AAxHA;EACE;IACE,WAAA;IAEA,UAAA;EA0HF;AACF;AArHA;EACE,mBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,+BAAA;AAuHF;AAtHE;EAAU,WAAA;EAAa,cAAA;EAAgB,WAAA;AA2HzC;AA1HE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA4HJ;AA3HI;EAAO,aAAA;AA8HX;AA7HI;EACE,aAAA;EACA,aAAA;AA+HN;AA5HE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AA8HJ;AA7HI;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA+HN;AA5HE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AA8HJ;AA7HI;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;EACA,mDAAA;EACA,sBAAA;AA+HN;AA5HE;EACE,aAAA;AA8HJ;AA3HM;EAAc,cAAA;AA8HpB;AA7HM;EAAa,aAAA;AAgInB;AA/HM;EACE,UAAA;EACA,oBAAA;EACA,mDAAA;AAiIR;AA9HI;EAEE,wBAAA;EACA,qDAAA;AA+HN;AA5HE;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;AA8HJ;AA3HE;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA6HJ;AA5HI;EACE,+BAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,qDAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AA8HN;AA7HM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;AA+HR;AA9HQ;EAAS,UAAA;AAiIjB;AAhIQ;EAAU,WAAA;AAmIlB;AAjIM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAmIR;AA/HQ;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAiIV;AAhIU;EAAK,gBAAA;AAmIf;AAlIU;EAAkB,kBAAA;AAqI5B;AAnIQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAqIV;AAnIQ;EACE,aAAA;AAqIV;AApIU;EAEE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,kDAAA;AAqIZ;;AA7HA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AAgIF;;AA7HA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AAgIF;;AA7HA;EACE,WAAA;AAgIF;;AA7HA;EACE;IACE,gCAAA;EAgIF;AACF;AA7HA;EACE;IACE,wBAAA;EA+HF;EA5HA;IACE,iBAAA;EA8HF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.header.hide-acc {\n  // background: color(inverse, darkest);\n  height: 60px;\n  background: #191919;\n}\n.tileName{\n  margin-left: 10px !important;\n}\n\n.headerlogo{\n  margin-left: 10%;\n}\n  \n#common-login-container {\n  .close-btn {\n    font-size: 20px;\n    padding: 10px;\n    position: absolute;\n    right: 33px;\n    top: -11px;\n  }\n  #loginModal-box {\n    display: none;\n    @include vendor-prefix(' box-shadow', none);\n    @include vendor-prefix(' border-radius', 0 0 0 0);\n    background: #333;\n    color: #ccc;\n    // display: block;\n    line-height: 15px;\n    padding: 0px 2px 0px;\n    position: absolute;\n    right:-35px;\n    top: 100%;\n    visibility: visible;\n    max-height: 600px;\n    width: 335px;\n    z-index: 999;\n    height: 270px;\n    text-align: left;\n    &.active{\n      display: inline-block;\n    }\n    @include respond-to(small){\n      position: fixed;\n      width: 100%;\n      top: 50px;\n      right: 0px;\n      .main-menu{\n        background: #333;\n      }\n    }\n  .heading{\n    cursor: default;\n    font: normal 22px Omnes-ATT-W02,Arial !important;\n    color: #fff;\n    padding: 15px 20px !important;\n    border-top: none !important;\n  }\n  .subHeading{\n    font-size: 18px;\n    font-family: Omnes-ATT-W02,Arial;\n    color: #FFFFFF;\n    text-align: left;\n  }\n  .content{\n    font-family: Omnes-ATT-W02,Arial;\n    color: #FFFFFF !important;\n    font-size: 14px;\n  }\n    ul{\n      li {\n        border-top: 1px solid #69707b;\n        font-family: Omnes-ATT-W02,Arial;\n        font-size: 14px;\n        padding: 0 20px;\n        color: #FFFFFF !important;\n        &.logoutBtn {\n          display: none;\n      }\n      a{\n        padding: 15px 0;\n      }\n      a:hover {\n        cursor: pointer;\n      }\n    }\n    li:hover{\n      background-color: #69707b !important;\n    }\n    .heading:hover{\n      background-color:  #333 !important;\n    }\n  }\n}\n}\n\n.firstnet-logo img {\n  padding: 6px 0 11px;\n  max-width: 347px;\n  max-height: 54px;\n}\n\n.main-menu {\n  max-height: 600px;\n  .close-btn {\n    left: 280px;\n    padding: 0;\n\n    .icon-close::before {\n      padding: 20px 10px 0;\n    }\n  }\n\n  li {\n    a {\n      padding-left: 15px;\n\n      &:focus {\n        padding-left: 9px;\n      }\n\n      &:hover {\n        padding-left: 9px;\n      }\n    }\n\n  }\n\n}\n\n.menu-seperator {\n  border-top: 1px solid color(inverse, lighter);\n}\n\n.global-logo::after {\n  height: 36px;\n}\n\n.hamburger-fn {\n  margin-left: 20px;\n}\n\n.logBtn {\n  padding-right: 20px;\n  padding-left: 10px;\n\n  @include respond-to(small) {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .hamburgerDesktop{\n    display: none !important;\n  }\n}\n\n@media (max-width: 1024px){\n.hamburgerDesktop{\n  display: block !important;\n}\n  }\n\n\n@include respond-to(small) {\n\n  .container-box {\n    height: 50px;\n\n    .user-info {\n      height: 50px;\n    }\n  }\n\n  .firstnet-logo {\n    line-height: 0;\n    margin-left: -33px;\n    padding: 15px 0 16px;\n\n    img{\n      content: url('../../../assets/img/firstnetLogoWhite.png');\n      height: 19px;\n      padding: 0;\n      // width: 84px;\n    }\n  }\n\n  .header.hide-acc {\n    height: 50px;\n    overflow: hidden;\n    padding: 0;\n  }\n  \n  .hamburger {\n    margin-left: 0;\n  }\n  \n.headerlogo{\n  margin-left: -4%;\n}\n.tileName{\n  margin-left: 0px !important;\n}\n\n  .logBtn {\n    padding-right: 0;\n  }\n\n  .main-menu {\n    // padding: 12px 0;\n    background: color(default, light);\n    // border: 1px solid color(inverse, darkest);\n  }\n\n  .menu-btn {\n    border: 0;\n    width: 50px;\n    #icon-log-out{\n      margin-right: -10px;\n    }\n  }\n\n\n  body {\n    &.m-open,\n    &.d-open {\n      &::after {\n        background: rgba(0, 0, 0, .8);\n      }\n    }\n  }\n\n  .user-profile {\n    a {\n      margin: 0;\n    }\n  }\n}\n\n.logoutBtn,.loginBtn  {\n    font-size: 14px !important;\n}\n\n.hamburger .main-menu li.menu-seperator {\n    border-top: 1px solid #959595;\n}\n\n.logoutBtn,.loginBtn,.log-out-text  {\n  cursor: pointer;\n}\n\n@-moz-document url-prefix() {\n  @include respond-to(small) {\n  .headerIcon\n   {\n    margin-bottom: 8px;\n    font-size: 26px;\n    } \n  .headerHam\n   {\n    margin-bottom: 9px;\n   }\n  .iconClose\n    {\n      margin-left: 66px;\n    }}\n  }\n\n  .dropdownMenu{\n    float: right;\n    margin-right: 22px;\n    margin-top: -34px;\n  }\n  .text{\n    margin-left: 52px;\n  }\n  @media (max-width: 1024px) {\n    .header {\n      // display: block;\n      position: fixed;\n      // overflow: hidden;\n      z-index:2;\n  }\n  }\n\n@media (min-width: 700px) {\n  .dropdownMenu{\n  margin-top: -32px}\n  .text{\n    margin-left: 35px !important;\n  }\n  .fortab{\n    width: 285px !important;\n  }\n}\n.fortab{\n  width: 200px  !important;\n}\n\nhr{\n  margin-top: 30px;\n  margin-bottom: 30px;\n  @include respond-to (small){\n    width: 116%;\n    margin-left: -46px !important;\n  } \n  @media only screen and (max-width: 1024px) and (min-width:400px) {\n    width: 115%;\n    margin-left: -46px !important;\n    }\n    @media only screen and (max-width: 1024px) and (min-width:700px) {\n    width: 111%;\n    margin-left: -46px !important;\n    }\n}\n\n.menu-sidebar .active {\n  background-color:#009FDB;\n}\n.menu-sidebar .has-subnav a{\npadding-left: 11px;}\n\n@media (max-width: 1024px) {\n  .header {\n    width: 100%;\n    // position: fixed;\n    z-index: 2;\n}\n}\n// body, html { margin: 0; font-family: arial; height: 100vh; background:  #ccc; }\n// *, *:before, *:after { box-sizing: border-box; }\n\n.nav-mobile {\n  background: #446CB3;\n  color: #FFF;\n  padding: 0;\n  margin: 0;\n  cursor: auto;  \n  font-size: 18px;\n  list-style-type: none;\n  box-shadow: 0 5px 5px -5px #333;\n  &:after { content: \"\"; display: table; clear: both; }\n  svg {\n    height: 45px;\n    width: 65px;\n    padding: 9px;\n    margin-top: 4px;\n    margin-left: -18px;\n    path { fill: #ffffff; }\n    &.icon-close { \n      display: none; \n      padding: 15px;\n    }\n  }\n  li {\n    width: 100%;\n    height: 45px;\n    line-height: 33px;\n    text-align: center;\n    float: left;\n    a {\n      display: block;\n      color: white;\n      width: 100%;\n      height: 100%;     \n      text-decoration: none;       \n    }      \n  }\n  .menu-button {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: pointer;\n    display: block;\n    &:after {\n      opacity: 0;\n      top: 45px;\n      content: \"\";\n      width: 100vw;\n      display: block;\n      position: fixed;\n      height: 100vh;\n      background: rgba(0,0,0,0.5);      \n      content: \"\";\n      pointer-events: none;\n      transition: opacity 0.2s cubic-bezier(0,0,0.3,1);  \n      transition-delay: 0.1s;      \n    }\n  }  \n  #menu-toggle {\n    display: none;\n    &.active ~ .menu-button,\n    &:checked ~ .menu-button {\n      .icon-close { display: block; }\n      .icon-open { display: none; }\n      &:after {\n        opacity: 1;\n        pointer-events: auto;\n        transition: opacity 0.3s cubic-bezier(0,0,0.3,1);        \n      }\n    }   \n    &.active ~ .menu-sidebar, \n    &:checked ~ .menu-sidebar {\n      transform: translateX(0);\n      transition: transform 0.3s cubic-bezier(0,0,0.3,1);\n    }    \n  }\n  .nav-text {\n    position:relative;\n    vertical-align:middle;\n    width:190px;\n    height: 12px;\n    font-weight: 400;\n    margin-left: 10px;\n    font-family: 'Omnes-ATT-W02';\n    font-size: 12px;\n    }\n    \n  .menu-container {\n    width: 65px;\n    float: left;\n    cursor: pointer;\n    position: absolute;\n    .menu-sidebar { \n      box-shadow: 5px 0 5px -5px #333;\n      display: block;\n      width: 75%;\n      bottom: 0;\n      background: black;\n      color: #333;\n      position: fixed;\n      transform: translateX(-405px);\n      transition: transform 0.3s cubic-bezier(0,0,0.3,1);   \n      top: 48px;\n      left:0px;\n      z-index: 2;\n      list-style-type: none;\n      padding: 0;\n      max-width: 400px;\n      .arrow {\n        position: absolute;\n        line-height: 50px;\n        font-size: 32px;\n        color: #555;\n        top: 0;\n        z-index: 0;\n        &.left { left: 25px; }\n        &.right { right: 25px; }\n      }      \n      li {\n        height: 48px;\n        line-height: 48px;\n        font-size: 12px; \n        text-align: left;\n        position: relative;\n        // border-bottom: 1px solid rgba(0,0,0,0.1);\n        // margin-bottom: 30px;\n        // &:hover { background-color:#009FDB; }                              \n        .menu-sub {\n          position: fixed;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          width: 0;\n          overflow: hidden;\n          background: white;\n          visibility: hidden;\n          transition: all 0.3s cubic-bezier(0,0,0.3,1);\n          border-left: 1px solid #ccc;  \n          list-style-type: none;\n          padding: 0;\n          margin: 0;    \n          z-index: 2;\n          max-width: 400px;\n          li { overflow: hidden; }\n          .menu-sub-title { padding-left: 50px; }\n         }\n        .submenu-label {\n          cursor: pointer;\n          width: 100%;\n          height: 100%;\n          display: block;\n        }\n        .submenu-toggle {\n          display: none; \n          &.active ~ .menu-sub,\n          &:checked ~ .menu-sub {\n            width: 65vw;\n            visibility: visible;\n            z-index: 1;\n            transition: width 0.35s cubic-bezier(0,0,0.3,1);\n          }\n        }               \n      }       \n    }\n  }\n}\n\n.last-login-info{\n  color: #fff;\n  font-size: 13px;\n  margin-right: 5px; \n}\n\n.last-login-time {\n  color: #fff;\n  font-size: 13px;\n  margin-right: 5px;\n}\n\n.login-info{\n  color: #fff;\n}\n\n@media only screen and (min-width: 1024px) {\n  .hide-mobile-view{\n    display: inline-block !important;\n  }\n}\n\n@media only screen and (max-width: 1024px){\n  .hide-mobile-view{\n    display: none !important;\n  }\n\n  .last-login-info{\n    margin-left: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
